export default __webpack_public_path__ + "static/media/wongart-1.415958c4.jpg";